import React from 'react';
import { useTranslation } from 'react-i18next';

const LanguageSwitcher: React.FC<{ className?: string }> = ({ className = '' }) => {
  const { i18n, t } = useTranslation();
  const isZh = (i18n.resolvedLanguage || i18n.language || 'en').startsWith('zh');

  const setLang = (code: 'en' | 'zh') => {
    void i18n.changeLanguage(code);
  };

  return (
    <div
      className={`inline-flex items-center rounded-full border border-line bg-graphite/80 p-0.5 ${className}`}
      role="group"
      aria-label={t('nav.langAria')}
    >
      <button
        type="button"
        onClick={() => setLang('en')}
        aria-pressed={!isZh}
        className={`rounded-full px-2.5 py-1 text-xs font-semibold tracking-wide transition ${
          !isZh ? 'bg-amber text-[#1a1200]' : 'text-muted hover:text-paper'
        }`}
      >
        EN
      </button>
      <button
        type="button"
        onClick={() => setLang('zh')}
        aria-pressed={isZh}
        className={`rounded-full px-2.5 py-1 text-xs font-semibold tracking-wide transition ${
          isZh ? 'bg-amber text-[#1a1200]' : 'text-muted hover:text-paper'
        }`}
      >
        中文
      </button>
    </div>
  );
};

export default LanguageSwitcher;
